import React from 'react';
import { Route, RouteProps, Redirect, RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AuthSelectors, UserInfoSelectors } from 'common/config/store';

interface ProtectedRouteProps extends Omit<RouteProps, 'component'> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<RouteComponentProps> | React.ComponentType<any>;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const isAuthenticated = useSelector(AuthSelectors.isAuthSelector);
  const isTemporary = useSelector(UserInfoSelectors.isTemporarySelector);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location },
              }}
            />
          );
        }

        if (isTemporary) {
          return (
            <Redirect
              to={{
                pathname: '/update-password',
                state: { from: props.location },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};
